/**
 * Fill-in placeholders in letter templates, written as [Insert County].
 *
 * Kept free of any editor dependency so both the editor (which shades them) and
 * the letter page (which warns before you print or send one unfilled) can use
 * the same definition, and so it can be tested on its own.
 */

// Bounded length and no newlines, so ordinary bracketed prose — a statute
// citation, an aside — is not mistaken for a placeholder.
export const PLACEHOLDER_RE = /\[[^\][\n]{2,80}\]/g;

/** Every unfilled placeholder in an HTML body, deduplicated, in order. */
export const findPlaceholders = (html) => {
  const text = (html || '').replace(/<[^>]*>/g, ' ');
  return [...new Set(text.match(PLACEHOLDER_RE) || [])];
};

/** Placeholders across a letter's body and its label/value details block. */
export const findLetterPlaceholders = (bodyHtml, fields) => {
  const fieldText = (fields || [])
    .map(f => `${f?.label || ''} ${f?.value || ''}`)
    .join(' ');
  return [...new Set([
    ...findPlaceholders(bodyHtml),
    ...findPlaceholders(fieldText),
  ])];
};
